import LogoutScreen from './LogoutScreen';

export default LogoutScreen;
